import {
    SAVE_PATIENT_PROFILE_REQUEST,
    SAVE_PATIENT_PROFILE_SUCCESS,
    SAVE_PATIENT_PROFILE_ERROR
  } from "./SavePatientProfileTypes";
  
  const initialState = {
    loading: false,
    isSubmitted: false,
    successMessage: "",
    errorMessage: "",
    savePatient: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case SAVE_PATIENT_PROFILE_REQUEST:
        return {
          ...state,
          isSubmitted: true,
          loading: true
        };
      case SAVE_PATIENT_PROFILE_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          savePatient: action.payload,
          successMessage: "Profile saved successfully! Please wait while redirecting...",
          errorMessage: ""
        };
      case SAVE_PATIENT_PROFILE_ERROR:
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          savePatient: [],
          errorMessage: action.payload
        };
      default:
        return state;
    }
  };
  